import { render, staticRenderFns } from "./checkoutCarrito.vue?vue&type=template&id=1db3c1aa&scoped=true&"
import script from "./checkoutCarrito.vue?vue&type=script&lang=js&"
export * from "./checkoutCarrito.vue?vue&type=script&lang=js&"
import style0 from "./checkoutCarrito.vue?vue&type=style&index=0&id=1db3c1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db3c1aa",
  null
  
)

export default component.exports